import React, { useEffect, useState } from "react";
import { fetchFAQs } from "../../services/api";
import SubHeader from "../../components/Header/SubmenuHeader";

const FAQ = () => {
  const [faqList, setFaqList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const getData = async () => {
      try {
        const data = await fetchFAQs();
        setFaqList(data);
      } catch (error) {
        console.error("Error fetching FAQ data:", error);
      }
    };
    getData();
  }, []);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const filteredFaqs = faqList.filter((faq) =>
    faq?.question?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-[#FDFEFF]">
      {/* Header */}
      <SubHeader title={"FAQ"} />

      {/* Search Bar */}
      <div className="flex justify-center mt-6 px-4">
        <div className="relative w-full max-w-[601px]">
          <input
            type="text"
            placeholder="Search The Questions"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full border border-gray-300 rounded-full px-4 py-2 text-sm shadow-sm focus:outline-none"
          />
          <button className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </button>
        </div>
      </div>

      {/* FAQ Accordion */}
      <div className="w-full max-w-[601px] mt-[39px] mx-auto px-4">
        {filteredFaqs.length === 0 ? (
          <p className="text-gray-500 text-center mt-4">No FAQs available.</p>
        ) : (
          filteredFaqs.map((faq, index) => (
            <div
              key={faq.id || index}
              className="border-b border-gray-200 py-3"
            >
              {/* Question */}
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full flex justify-between items-center text-left focus:outline-none"
              >
                <div className="flex gap-2">
                  <span className="text-sm font-medium text-gray-800">
                    {index + 1}.
                  </span>
                  <span className="text-sm md:text-base font-medium text-gray-900">
                    {faq.question}
                  </span>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={`w-5 h-5 text-gray-600 transform transition-transform duration-300 ${
                    openIndex === index ? "rotate-180" : "rotate-0"
                  }`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {/* Answer */}
              {openIndex === index && (
                <div className="pl-6 mt-2 text-sm text-gray-600">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: faq.formatted_answer,
                    }}
                  />
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default FAQ;
